"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var overflow = _a.overflow;
    if (!overflow) {
        return '';
    }
    if (typeof overflow === 'string') {
        return "overflow: " + overflow + ";";
    }
    var _b = overflow.vertical, vertical = _b === void 0 ? '' : _b, _c = overflow.horizontal, horizontal = _c === void 0 ? '' : _c;
    return "\n    " + (vertical && "overflow-y: " + vertical + ";") + "\n    " + (horizontal && "overflow-x: " + horizontal + ";") + "\n  ";
});
